const config = require('./' + process.env.REACT_APP_PROJECT_NAME + '-header-config');
export default config;
